<template>
  <!-- (评论管理)原帖详情 -->
  <div class="viewPost">
    <HeadTitle></HeadTitle>
    <main class="box">
      <div v-for="(item, index) in messList" :key="index">
        <div class="contentBox" v-if="item.msg_type === 'text'">
          <div v-for="(item, index) in item.msg_content" :key="index">
            <div>
              {{ item.content }}
            </div>
          </div>
        </div>
        <div class="contentBox" v-if="item.msg_type === 'img'">
          <img class="imageBox" :src="item.msg_content" alt="描述" srcset="" />
        </div>
        <div class="contentBox" v-if="item.msg_type === 'video'">
          <video class="videoBox" controls :src="item.msg_content"></video>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { previewForumCommentAPI } from "@/api/commentManagement";
import HeadTitle from "../../components/HeadTitle";
export default {
  components: {
    HeadTitle,
  },
  name: "ViewPost",
  data() {
    return {
      title: "产品创造于工厂,而品牌创造与心灵",
      content:
        "灵感是业余者的专属，我们的专业人生.灵感是业余者的专属，我们的专业人生",
      image: require("../../assets/icon/fengjing3.png"),
      messList: [],
    };
  },
  created() {
    this.getPreview();
  },
  methods: {
    getPreview() {
      let pid = this.$route.query?.pid;
      const data = {
        pid: pid,
      };
      previewForumCommentAPI(data).then((res) => {
        if (res.data.code === 1) {
          this.messList = res.data.data?.messList || [];
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.viewPost {
  margin-top: 120px;
  margin-bottom: 40px;

  .box {
    margin: 100px 24px 0px 24px;

    .contentBox {
      font-size: 36px;

      // color: #969799;
      .imageBox {
        width: 100%;
        height: 100%;
      }

      .videoBox {
        width: 100%;
        height: 400px;
      }
    }

    // .title {
    //   width: 100%;
    //   margin: 20px 0px;
    // }
    // .content {
    //   font-size: 26px;
    //   color: #969799;
    //   margin: 12px 0px;
    // }
  }
}</style>
